// extracted by mini-css-extract-plugin
export default {"header-slider":"Header_header-slider__7BGI3","header-slider__img":"Header_header-slider__img__5nAP5"};